(function(){
  var toastEl = document.getElementById('toast');
  function showToast(msg){ if(!toastEl) return; toastEl.textContent = msg; toastEl.classList.add('show'); setTimeout(function(){ toastEl.classList.remove('show'); }, 2600); }

  /* ══ LANDINGPAGE ═════════════════════════════════════ */
  var root = document.querySelector('.rova-page:not(.rova-product-page):not(.rova-cart-page)');
  if (root) {
    var VARIANT_ID = Number(root.getAttribute('data-rova-variant-id'));

    /* ── Varianten: Preis, Compare-at-Price und Rabatt aktualisieren ── */
    var select = root.querySelector('[data-rova-variant-select]');
    function applyVariant(opt){
      if(!opt) return;
      VARIANT_ID = Number(opt.value);
      var price = opt.getAttribute('data-price') || '';
      var compare = opt.getAttribute('data-compare') || '';
      var badge = opt.getAttribute('data-badge') || '';
      root.querySelectorAll('[data-rova-price]').forEach(function(el){ el.innerHTML = price; });
      root.querySelectorAll('[data-rova-compare]').forEach(function(el){
        el.innerHTML = compare; el.hidden = !compare;
      });
      root.querySelectorAll('[data-rova-badge]').forEach(function(el){
        el.textContent = badge; el.hidden = !badge;
      });
    }
    if(select){
      select.addEventListener('change', function(){ applyVariant(select.options[select.selectedIndex]); });
    }

    /* ── Kaufen: echtes Shopify-Produkt in den nativen Warenkorb legen ── */
    root.querySelectorAll('.rova-order').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.disabled) return;
        if(!VARIANT_ID){ window.location.href = root.getAttribute('data-rova-url') || '/cart'; return; }
        var original = btn.textContent;
        btn.disabled = true; btn.textContent = 'Wird vorbereitet …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
        }).then(function(r){
          if(!r.ok) throw new Error('cart');
          return r.json();
        }).then(function(){
          showToast('Im Warenkorb – weiter zur sicheren Kasse');
          window.location.href = '/cart';
        }).catch(function(){
          btn.disabled = false; btn.textContent = original;
          showToast('Etwas hat nicht geklappt – bitte erneut versuchen.');
        });
      });
    });
  }

  /* ══ PRODUKTSEITE (native Shopify-Produktdaten) ═══════ */
  var pp = document.querySelector('.rova-product-page');
  if (pp) {
    var dataEl = document.querySelector('[data-pp-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch(e) { variants = []; }
    var idInput = pp.querySelector('[data-pp-variant-input]');
    var submit = pp.querySelector('[data-pp-submit]');
    var submitText = pp.querySelector('[data-pp-submit-text]');
    var stock = pp.querySelector('[data-pp-stock]');
    var optionSelects = Array.prototype.slice.call(pp.querySelectorAll('[data-pp-option-select]'));

    function money(cents){
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-CH', {
          style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF'
        }).format(cents / 100);
      } catch(e) { return (cents / 100).toFixed(2); }
    }

    function updateVariant(){
      if(!optionSelects.length) return;
      var chosen = optionSelects.map(function(s){ return s.value; });
      var match = variants.filter(function(v){
        return chosen.every(function(val, i){ return v.options[i] === val; });
      })[0];
      if(!match) return;
      if(idInput) idInput.value = match.id;
      var priceEl = pp.querySelector('[data-pp-price]');
      var compareEl = pp.querySelector('[data-pp-compare]');
      var badgeEl = pp.querySelector('[data-pp-badge]');
      if(priceEl) priceEl.textContent = money(match.price);
      var onSale = match.compare_at_price && match.compare_at_price > match.price;
      if(compareEl){ compareEl.textContent = onSale ? money(match.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if(badgeEl){
        badgeEl.textContent = onSale ? '–' + Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price) + ' %' : '';
        badgeEl.hidden = !onSale;
      }
      if(submit) submit.disabled = !match.available;
      if(submitText) submitText.textContent = match.available ? 'Jetzt bestellen' : 'Ausverkauft';
      if(stock) stock.textContent = match.available ? 'Auf Lager · sofort versandfertig' : 'Derzeit nicht verfügbar';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
    optionSelects.forEach(function(s){ s.addEventListener('change', updateVariant); });

    /* Menge +/- */
    var qtyInput = pp.querySelector('[data-pp-qty-input]');
    pp.querySelectorAll('[data-pp-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        if(!qtyInput) return;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-pp-qty'), 10));
        qtyInput.value = next;
      });
    });

    /* Bildergalerie */
    var mainImg = pp.querySelector('#ProductMainImage');
    pp.querySelectorAll('[data-product-thumb]').forEach(function(t){
      t.addEventListener('click', function(){
        if(mainImg) mainImg.src = t.getAttribute('data-full');
      });
    });

    /* Add to cart via Shopify Cart API */
    var form = pp.querySelector('#ProductForm') || pp.querySelector('form.product-form');
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        if(submit && submit.disabled) return;
        var original = submitText ? submitText.textContent : '';
        if(submit) submit.disabled = true;
        if(submitText) submitText.textContent = 'Wird vorbereitet …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }] })
        }).then(function(r){
          if(!r.ok) throw new Error('cart');
          return r.json();
        }).then(function(){
          showToast('Im Warenkorb');
          window.location.href = '/cart';
        }).catch(function(){
          if(submit) submit.disabled = false;
          if(submitText) submitText.textContent = original;
          showToast('Etwas hat nicht geklappt – bitte erneut versuchen.');
        });
      });
    }
  }

  /* ══ WARENKORB ═══════════════════════════════════════ */
  var cartPage = document.querySelector('.rova-cart-page');
  if (cartPage) {
    var cartForm = cartPage.querySelector('[data-cart-form]');
    cartPage.querySelectorAll('[data-cart-qty]').forEach(function(b){
      b.addEventListener('click', function(){
        var input = b.parentNode.querySelector('[data-cart-qty-input]');
        if(!input) return;
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-cart-qty'), 10));
        input.value = next;
        if(cartForm){
          if(!cartForm.querySelector('input[name="update"]')){
            var hidden = document.createElement('input');
            hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '';
            cartForm.appendChild(hidden);
          }
          cartForm.submit();
        }
      });
    });
  }

  /* ── Cookie-Hinweis ── */
  var cookieBox = document.getElementById('cookie');
  if(cookieBox){
    try{
      if(!localStorage.getItem('rova-cookie-choice')) cookieBox.classList.add('show');
      cookieBox.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click', function(){
          localStorage.setItem('rova-cookie-choice', b.getAttribute('data-cookie'));
          cookieBox.classList.remove('show');
        });
      });
    }catch(e){ cookieBox.classList.add('show'); }
  }

  /* ── Countdown ── */
  function tick(){
    var now = new Date(); var end = new Date(now); end.setHours(24,0,0,0);
    var d = Math.max(0, Math.floor((end - now)/1000));
    var h = document.getElementById('cd-h'), m = document.getElementById('cd-m'), s = document.getElementById('cd-s');
    if(!h) return;
    h.textContent = String(Math.floor(d/3600)).padStart(2,'0');
    m.textContent = String(Math.floor(d%3600/60)).padStart(2,'0');
    s.textContent = String(d%60).padStart(2,'0');
  }
  tick(); setInterval(tick, 1000);
})();
